import Axios from 'axios'
import config from '../app.config'

export default {
	getStatus,
	showStatus,
	updateStatus,
	createStatus,
	deleteStatus,
	getListStatus
}
async function getStatus(payload) {
	return await Axios.get(`${config.LOCAL_API_URL}/status`, { params: payload })
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
async function showStatus(id) {
	return await Axios.get(`${config.LOCAL_API_URL}/status/` + id)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function updateStatus(data) {
	return await Axios.put(`${config.LOCAL_API_URL}/status/` + data.id, data)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function deleteStatus(params) {
	return await Axios.delete(`${config.LOCAL_API_URL}/status`, { data: params })
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function createStatus(params) {
	return await Axios.post(`${config.LOCAL_API_URL}/status`, params)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}

async function getListStatus(type) {
	return await Axios.get(`${config.LOCAL_API_URL}/getListStatus/${type}`)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
